// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.body * {
  background-color: white;
}
.privacy {
  margin-top: 50px;
}`, "",{"version":3,"sources":["webpack://./src/pages/privacy/privacy.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;AACzB;AACA;EACE,gBAAgB;AAClB","sourcesContent":[".body * {\n  background-color: white;\n}\n.privacy {\n  margin-top: 50px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
